import { render, staticRenderFns } from "./PaginaAllegatiDE.vue?vue&type=template&id=82fe079a"
import script from "./PaginaAllegatiDE.vue?vue&type=script&lang=js"
export * from "./PaginaAllegatiDE.vue?vue&type=script&lang=js"
import style0 from "./PaginaAllegatiDE.vue?vue&type=style&index=0&id=82fe079a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports